<template>
    <div class="section pt-0 mt-0">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">QHLS സെന്റർ വിവരങ്ങൾ</h3>
        </div>
    </div>
    <div class="section text-center" v-if="loading_list">
        <div class="spinner-border text-secondary" role="status"></div>
    </div>
    <div class="section pb-2" v-if="!loading_list">
        <div class="card pl-2 pr-2 mt-1">
            <div class="listed-detail mt-1">
                <h3 class="text-center mt-1">{{requestData.center_name}}</h3>
            </div>
            <ul class="listview flush transparent simple-listview no-space mt-1">
                <li>
                    <strong>Status</strong>
                    <span :class="requestData.approve_status == 'Pending Approval'?'text-warning':'text-success'">{{requestData.approve_status}}</span>
                </li>
                <li v-if="requestData.zone || requestData.unit">
                    <strong>Level</strong>
                    <span class="text-primary">{{requestData.user_level == 3?requestData.zone.name:requestData.unit.name}} {{requestData.user_level == 3?'Zone':' Unit'}}</span>
                </li>
                <li>
                    <strong>Adress</strong>
                    <span class="text-primary">{{requestData.center_adress}}</span>
                </li>
                <li>
                    <strong>Centre Type</strong>
                    <span class="text-primary">{{requestData.center_type}}</span>
                </li>
                <li>
                    <strong>No Of Rooms</strong>
                    <span class="text-primary">{{requestData.no_of_rooms}}</span>
                </li>
                <li>
                    <strong>No Of Benches</strong>
                    <span class="text-primary">{{requestData.no_of_benches}}</span>
                </li>
                <li>
                    <strong>No Of Desks</strong>
                    <span class="text-primary">{{requestData.no_of_desks}}</span>
                </li>
                <li>
                    <strong>No Of Chairs</strong>
                    <span class="text-primary">{{requestData.no_of_chairs}}</span>
                </li>
                <li>
                    <strong>No Of Estimated Registrations</strong>
                    <span class="text-primary">{{requestData.no_of_estimated_registrations}}</span>
                </li>
                <li>
                    <strong>Office Room</strong>
                    <span class="text-primary">{{requestData.office_room == 'Y'?'Yes':'No'}}</span>
                </li>
                <li>
                    <strong>Library</strong>
                    <span class="text-primary">{{requestData.library == 'Y'?'Yes':'No'}}</span>
                </li>
                <li>
                    <strong>Toilet</strong>
                    <span class="text-primary">{{requestData.toilet == 'Y'?'Yes':'No'}}</span>
                </li>
                <li>
                    <strong>Rest Area</strong>
                    <span class="text-primary">{{requestData.rest_area == 'Y'?'Yes':'No'}}</span>
                </li>
                <li>
                    <strong>Projector</strong>
                    <span class="text-primary">{{requestData.projector == 'Y'?'Yes':'No'}}</span>
                </li>
                <li>
                    <strong>Board</strong>
                    <span class="text-primary">{{requestData.board == 'Y'?'Yes':'No'}}</span>
                </li>
                <li>
                    <strong>Fan Ac</strong>
                    <span class="text-primary">{{requestData.fan_ac == 'Y'?'Yes':'No'}}</span>
                </li>
                <li>
                    <strong>Drinking Water</strong>
                    <span class="text-primary">{{requestData.drinking_water == 'Y'?'Yes':'No'}}</span>
                </li>

                <li>
                    <strong>Org Cordinator</strong>
                    <span class="text-primary">{{requestData.org_member?requestData.org_member.name:''}}</span>
                </li>
                <li>
                    <strong>Youth Cordinator</strong>
                    <span class="text-primary">{{requestData.youth_member?requestData.youth_member.name:''}}</span>
                </li>
                <li v-if="requestData.women_member || requestData.women_cordinator">
                    <strong>Women's Coordinator</strong>
                    <span class="text-primary">{{ requestData.women_member ? requestData.women_member.name : '' }}</span>
                </li>
                <li v-if="requestData.center_reg_no || requestData.reg_no">
                    <strong>Centre Registration No</strong>
                    <span class="text-success">{{ requestData.reg_no || requestData.center_reg_no }}</span>
                </li>
                <li v-if="permissions.certificate">
                    <strong>Certificate</strong>
                    <span><button type="button" class="btn btn-outline-primary btn-sm" @click="downloadCertificate">Download PDF</button></span>
                </li>
                <li class="contact-row">
                    <strong>Added By</strong>
                    <div class="contact-info">
                        <span class="contact-name">{{ requestData.added_by_name }}</span>
                        <span v-if="requestData.added_by_phone" class="contact-phone">
                            +{{ requestData.added_by_country_code || '91' }}{{ requestData.added_by_phone }}
                        </span>
                        <div v-if="requestData.added_by_phone" class="contact-actions">
                            <a :href="'tel:+' + (requestData.added_by_country_code || '91') + requestData.added_by_phone"
                                class="contact-btn call-btn" title="Call">
                                <ion-icon name="call-outline"></ion-icon>
                            </a>
                            <a :href="'https://wa.me/' + (requestData.added_by_country_code || '91') + requestData.added_by_phone"
                                target="_blank"
                                class="contact-btn whatsapp-btn" title="WhatsApp">
                                <ion-icon name="logo-whatsapp"></ion-icon>
                            </a>
                        </div>
                    </div>
                </li>
                <li v-if="requestData.updated_by_name" class="contact-row">
                    <strong>Updated By</strong>
                    <div class="contact-info">
                        <span class="contact-name">{{ requestData.updated_by_name }}</span>
                        <span v-if="requestData.updated_by_phone" class="contact-phone">
                            +{{ requestData.updated_by_country_code || '91' }}{{ requestData.updated_by_phone }}
                        </span>
                        <div v-if="requestData.updated_by_phone" class="contact-actions">
                            <a :href="'tel:+' + (requestData.updated_by_country_code || '91') + requestData.updated_by_phone"
                                class="contact-btn call-btn" title="Call">
                                <ion-icon name="call-outline"></ion-icon>
                            </a>
                            <a :href="'https://wa.me/' + (requestData.updated_by_country_code || '91') + requestData.updated_by_phone"
                                target="_blank"
                                class="contact-btn whatsapp-btn" title="WhatsApp">
                                <ion-icon name="logo-whatsapp"></ion-icon>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="transparent pt-2" v-if="editReqStatus">
            <div class="text-center mb-2" :class="editStatusClass(editReqStatus.status)" style="font-size:13px;font-weight:700;">
                Edit Request: {{ editStatusLabel(editReqStatus.status) }}
                <template v-if="editReqStatus.by"> · {{ editReqStatus.by }}</template>
            </div>
        </div>
        <div class="transparent pt-2">
            <router-link
                v-if="canRequestEdit && (!editReqStatus || editReqStatus.status !== 'pending')"
                :to="'/org/' + $route.params.sub_level + '/' + (requestData.user_level_id || 0) + '/qhls-registration/' + requestData.id + '?editRequest=1'"
                class="btn btn-outline-primary btn-block btn-lg mb-2"
            >
                <ion-icon name="create-outline"></ion-icon>
                <span>Request Edit</span>
            </router-link>
            <button type="button" @click="getActionModel" v-if="permissions.action" class="btn btn-primary btn-block btn-lg" :disabled="btnLoading">
                <span v-show="btnLoading" class="spinner-border spinner-border-sm"></span>
                <span>Action</span>
            </button>
        </div>
    </div>
    
        <!-- actionModel -->
        <div class="modal fade action-sheet" id="actionModel" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Action</h5>
                    </div>
                    <div class="modal-body">
                        <div class="action-sheet-content">
                            <div class="form-group basic">
                                <label class="label" for="stay"><span>Comments</span></label>
                                <div class="form-group basic">
                                    <div class="input-wrapper">
                                        <textarea class="form-control" rows="5" name="action_comments" v-model="action_comments">
                                                                    </textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group basic" v-if="permissions.action">
                                <button type="button" @click="approve()" class="btn btn-primary btn-block btn-lg" :disabled="loading">
                                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                                <span>Approve</span></button>
                            </div>
                        </div>
        
                    </div>
                </div>
            </div>
        </div>
        <!-- actionModel -->
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params" ref="dialog_model"></dialog-model>
</template>

<script>
import * as yup from "yup";
import UserService from "../../services/user.service";
import $ from "jquery";
import AlertModel from "../layouts/AlertModel.vue";
import DialogModel from "../layouts/DialogModel.vue";
export default {
    name: "Admin List",
    props: {
        unit_id: null
    },
    components: {
        AlertModel,
        DialogModel,
    },
    data() {
        const schema = yup.object().shape({});
        return {
            loading: false,
            loading_list: false,
            loading_page: false,
            schema,
            user_level: "",
            unit: [],
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            dialog_action_params: [],
            requestData:[],
            action_comments:'',
            editReqStatus: null,   // { status, by } for this centre
            permissions: {
                edit: true
            }
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        childLength() {
            return parseInt(this.formData.lessthan_16_count);
        },
        // State + managing levels may raise an edit request on an approved centre.
        canRequestEdit() {
            if (!this.currentUser || !this.requestData) return false;
            if (String(this.requestData.approve_status) !== 'Approved') return false;
            const ul = parseInt(String(this.currentUser.user_level), 10);
            return ul >= 1 && ul <= 5;
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.user_level = parseInt(this.$route.params.sub_level);
            if (this.unit_id == this.currentUser.unit_id || this.currentUser.user_level == 4) {
                this.editable = true;
            } else {
                this.editable = false;
            }

            this.$root.updateParent("QHLS സെന്റർ");
            if (this.$route.params.id) {
                this.getCreCenterData(this.$route.params.id);
            }
        }

        window.onpopstate = function() {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    methods: {
        editStatusLabel(s) {
            return s === 'pending' ? 'Requested' : s === 'approved' ? 'Approved' : s === 'denied' ? 'Denied' : s;
        },
        editStatusClass(s) {
            return s === 'pending' ? 'text-warning' : s === 'approved' ? 'text-success' : 'text-danger';
        },
        loadEditReqStatus() {
            if (!this.requestData || !this.requestData.id) return;
            UserService.authPostRequest('get-cre-edit-requests', { center_id: this.requestData.id }).then(
                (response) => {
                    if (response.data.status === 'success') {
                        const list = response.data.data.list || [];
                        this.editReqStatus = list.length ? { status: list[0].status, by: list[0].requested_by_name } : null;
                    }
                },
                () => {}
            );
        },
        handleRegistration(data) {
            console.log(data);
            this.loading = true;
            const formData_ = new FormData();
            if (this.editable_id) {
                formData_.append('editable_id', this.editable_id);
            }

            let user_level = this.formData.change_level;
            let user_level_id = 0;
            if (user_level == 1) {
                user_level_id = 0;
            } else if (user_level == 2) {
                user_level_id = this.currentUser.district_id;
            } else if (user_level == 3) {
                user_level_id = this.currentUser.zone_id;
            } else if (user_level == 4) {
                user_level_id = this.currentUser.unit_id;
            }

            formData_.append('TYPE', 'QHLS');
            formData_.append('user_level', user_level);
            formData_.append('user_level_id', user_level_id);

            formData_.append('center_level', this.formData.change_level);
            formData_.append('center_name', this.formData.center_name);
            formData_.append('center_adress', this.formData.center_adress);
            formData_.append('center_type', this.formData.center_type);

            formData_.append('no_of_rooms', this.formData.no_of_rooms);
            formData_.append('no_of_benches', this.formData.no_of_benches);
            formData_.append('no_of_desks', this.formData.no_of_desks);
            formData_.append('no_of_chairs', this.formData.no_of_chairs);
            formData_.append('no_of_estimated_registrations', this.formData.no_of_estimated_registrations);

            formData_.append('office_room', this.formData.office_room);
            formData_.append('library', this.formData.library);
            formData_.append('toilet', this.formData.toilet);
            formData_.append('rest_area', this.formData.rest_area);
            formData_.append('projector', this.formData.projector);
            formData_.append('board', this.formData.board);
            formData_.append('fan_ac', this.formData.fan_ac);
            formData_.append('drinking_water', this.formData.drinking_water);

            formData_.append('org_cordinator', this.org_member.id);
            formData_.append('youth_cordinator', this.youth_member.id);
            formData_.append('student_cordinator', this.formData.student_cordinator);

            UserService.authPostRequest("store-cre-center", formData_).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.alert_type = "Success";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == "warning") {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.alert_type = "Error";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getCreCenterData(id) {
            this.loading_list = true;
            let data = {
                id: id
            }
            UserService.authPostRequest('show-cre-center', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.requestData = response.data.data.center;
                        this.permissions = response.data.data.permissions;
                        this.loading_list = false;
                        this.loadEditReqStatus();
                    }
                },
                (error) => {
                    this.message =
                        (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                        this.loading_list = false;
                }
            );
        },
        getActionModel(){
            $('#actionModel').modal('show');
        },
        async downloadCertificate() {
            const id = this.requestData.id;
            if (!id) return;

            // Open a blank window synchronously (within the user gesture) so iOS Safari
            // doesn't block it. We navigate it to the blob URL after the async fetch.
            const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
            const preWin = isIOS ? window.open('', '_blank') : null;

            try {
                const response = await UserService.authPostRequest(
                    'download-qhls-center-certificate',
                    { id },
                    { responseType: 'blob' }
                );

                const blob = response.data;
                const contentType = (response.headers && response.headers['content-type']) || '';
                if (contentType.indexOf('application/json') !== -1) {
                    if (preWin) preWin.close();
                    const text = await new Promise((res) => {
                        const r = new FileReader();
                        r.onload = () => res(r.result);
                        r.readAsText(blob);
                    });
                    const json = JSON.parse(text);
                    this.alert_type = 'Warning';
                    this.alert_message = json.message || 'Download failed';
                    this.$refs.alert_model.openModel();
                    return;
                }

                const url = window.URL.createObjectURL(blob);
                if (preWin) {
                    // iOS: navigate the pre-opened window to the blob URL
                    preWin.location.href = url;
                } else {
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'QHLS-Centre-Certificate.pdf';
                    a.click();
                    setTimeout(() => URL.revokeObjectURL(url), 10000);
                }
            } catch (err) {
                if (preWin) preWin.close();
                let msg = 'Certificate download failed.';
                if (err?.response?.data && typeof err.response.data === 'object' && !(err.response.data instanceof Blob)) {
                    msg = err.response.data.message || msg;
                } else if (err?.message) {
                    msg = err.message;
                }
                this.alert_type = 'Error';
                this.alert_message = msg;
                this.$refs.alert_model.openModel();
            }
        },
        approve() {
            this.loading = true;
            let data = {
                id: this.requestData.id,
                comments: this.action_comments
            }
            UserService.authPostRequest('update-cre-center-status', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        $('#actionModel').modal('hide');
                        this.getCreCenterData(this.requestData.id);
                        this.alert_type = 'Success';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'warning') {
                        this.alert_type = 'Warning';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else if (response.data.status == 'error') {
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.loading = false;
                    } else {
                        this.loading = false;
                    }
                },
                (error) => {
                    this.loading = false;

                    this.messafe = (error.response &&
                            error.response.data &&
                            error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        }
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    opacity: 1;
}

.form-check-input:disabled~.form-check-label,
.form-check-input[disabled]~.form-check-label {
    color: #060606;
}

/* Contact row layout */
.contact-row {
    display: flex;
    align-items: flex-start !important;
    justify-content: space-between;
    padding: 8px 0;
}

.contact-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 3px;
}

.contact-name {
    color: #1a418c;
    font-weight: 500;
    font-size: 14px;
    text-align: right;
}

.contact-phone {
    color: #6c757d;
    font-size: 12px;
    text-align: right;
}

.contact-actions {
    display: flex;
    gap: 6px;
    margin-top: 2px;
}

.contact-btn {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    text-decoration: none;
    transition: opacity 0.2s;
}

.contact-btn:active {
    opacity: 0.7;
}

.call-btn {
    background-color: #e8f0fe;
    color: #1a418c;
    border: 1px solid #c5d5f7;
}

.whatsapp-btn {
    background-color: #e8f8ef;
    color: #25d366;
    border: 1px solid #b7e8ca;
}
</style>
